import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

interface Props {
  isMarginTop?: boolean;
  isMember?: boolean;
}
const Main = styled.div<Props>`
  .bottom-loading {
    margin-top: var(--space-32);
  }
  .second-line {
    margin-top: var(--space-12);
  }
  .second-bottom {
    margin: var(--space-8) var(--space-0) var(--space-0) var(--space-12);
    gap: var(--space-20);
  }
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  ${(props: Props) =>
    props.isMarginTop &&
    css`
      margin-top: var(--space-24);
      ${mobile_xl(css`
        margin-top: var(--space-8);
      `)}
    `}
  ${(props: Props) =>
    props.isMember &&
    css`
      ${mobile_xl(css`
        margin-top: var(--space-0);
      `)}
    `}
`;

const Top = styled.div`
  border-radius: var(--border-radius-full);
  width: 100px;
  height: 12px;
  background-color: var(--background-muted);
  margin-left: var(--space-12);
`;

const Line = styled.div`
  width: 918px;
  height: 1px;
  background-color: var(--background-muted);
  margin-top: var(--space-6);
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-18);
  margin: var(--space-12) var(--space-0) var(--space-0) var(--space-12);
`;
const First = styled.div`
  display: flex;
  gap: var(--space-10);
  .second {
    width: 520px;
    ${mobile_xl(css`
      width: 360px;
    `)}
  }
  .third {
    width: 280px;
  }
  .forth {
    width: 170px;
  }
`;

const Left = styled.div`
  border-radius: var(--border-radius-full);
  width: 14px;
  height: 14px;
  background-color: var(--background-muted);
`;
const Right = styled.div`
  border-radius: var(--border-radius-full);
  width: 480px;
  height: 12px;
  background-color: var(--background-muted);
  ${mobile_xl(css`
    width: 360px;
  `)}
`;

export { Main, Top, Line, Bottom, First, Left, Right };
